// extracted by mini-css-extract-plugin
module.exports = {"separator":"Separator_separator__S_qku","horizontal":"Separator_horizontal__m5ckH","vertical":"Separator_vertical__jVIi2"};